import React from 'react';
import { Form } from 'react-bootstrap';
import styles from '../AddProducts.module.scss';

const OptionsToggle = ({ options = [], onToggle }) => {
    return (
        <div className={styles.optionContainer}>
            {options.map(opt => (
                <Form.Check
                    key={opt.id}
                    type="checkbox"
                    id={opt.id}
                    name={opt.name}
                    label={opt.label}
                    checked={Boolean(opt.checked)}
                    onChange={(e) => onToggle(opt.name, e.target.checked)}
                    className="mb-2"
                />
            ))}
        </div>
    );
};

export default OptionsToggle;
